import {defineMessages} from 'react-intl';

const messages = defineMessages({
    password_form_error_empty_field: {
        id: 'create-password.limit_form_error_empty_field',
        defaultMessage: 'Поле обязательно для заполнения'
    },
    password_form_error_mismatch: {
        id: 'create-password.password_form_error_mismatch',
        defaultMessage: 'Подтверждение пароля не совпадает'
    }
});

const PasswordFormValidation = function(values) {
    const errors = {};

    let code = values.Code;
    let newPassword = values.NewPassword;
    let newPasswordConfirm = values.NewPasswordConfirm;

    if (!code) {
        errors.Code = messages.password_form_error_empty_field;
    }

    if (!newPassword || !newPassword.length) {
        errors.NewPassword = messages.password_form_error_empty_field;
    }

    if (!newPasswordConfirm || !newPasswordConfirm.length) {
        errors.NewPasswordConfirm = messages.password_form_error_empty_field;
    } else if (newPassword != newPasswordConfirm) {
        errors.NewPasswordConfirm = messages.password_form_error_mismatch;
    }

    return errors;
};

export default PasswordFormValidation;


// WEBPACK FOOTER //
// ./js/sport-betting/components/PasswordRecoveryViaPhoneValidation.js